import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import createSagaMiddleware from 'redux-saga';

// Middlewares
import segmentMiddleware from './eventsTrackingMiddleware';
import trackPageViewMiddleware from './trackPageViewMiddleware';

// Root cards saga
import cardsRootSaga from '../cards/sagas';

// Reducers
import reducers from '../reducers';
import cards from '../cards/reducers';

// Configs for persisting some values of cards reducer
const cardsPersistConfig = {
  key: 'cards',
  storage,
  whitelist: ['trackedEvents'],
  stateReconciler: autoMergeLevel2
};

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] }] */
const composeEnhancers = (window.zola.env === 'development' || window.zola.env === 'staging') ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

let middlewares = [thunk, trackPageViewMiddleware];

if (typeof window.analytics !== 'undefined') {
  middlewares = [...middlewares, segmentMiddleware];
}

// Add saga middleware
middlewares = [...middlewares, sagaMiddleware];

const enhancers = composeEnhancers(
  applyMiddleware(...middlewares)
);

// Persisting cards reducer only
const finalReducers = combineReducers({
  ...reducers,
  cards: persistReducer(cardsPersistConfig, cards),
  routing: routerReducer
});

const store = createStore(finalReducers, enhancers);
const persistor = persistStore(store);

// Run root saga on init
sagaMiddleware.run(cardsRootSaga);

export default {
  store,
  persistor
};



// WEBPACK FOOTER //
// ./src/store/index.js